@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.voided-tracking-number {
  text-decoration: line-through;
}

.label-created-column {
  .truncate();
  width: 100%;
  color: @columns--icon-message--text-color;
  font-size: 13px;
  line-height: 30px;
}

.label-created-date {
  padding-left: 5px;
}
